import gql from 'graphql-tag';

const deleteAssetMutation = gql`
  mutation DeleteAssetMutation($assetId: String!) {
    deleteAsset(assetId: $assetId) {
      assetId
    }
  }
`;

export default (() => ({
  mutation: deleteAssetMutation,
  module: 'assets',
  buildVariables: (assetId) => ({
    assetId
  })
}));